/*
创建者 左晨(2019.07.24)
奖金积分转商城购物积分页面
*/
<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      >
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>{{titleName}}</h2>
        <div class="content">
          <p style="margin-bottom: 10px;">可兑换金额：{{showTransfer}}</p>
          <form
            action="api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253"
            name="transferForm"
            class="alipayform"
            method="POST"
            target="_blank"
          >
            <div class="element">
              <div class="etitle">兑换金额:</div>
              <div class="einput">
                <input
                  type="text"
                  placeholder="请输入需要兑换成通用商城购物积分的金额"
                  id="WIDtotal_fee"
                  name="WIDtotal_fee"
                  value="10"
                  v-model="transModel"
                  @input="getCalGold"
                >
                <span
                  v-if="calGold1"
                  style="margin-left: 10px; color: #ff0000;"
                >税后实际到账积分：{{calGold1}}</span>
              </div>
              <br>
              <!-- <div class="einput" v-if="isFirstBuy == 1">
              <input type="text" placeholder="请输入需要兑换成店长采购积分的金额" id="FirstBuy_fee"
                     name="FirstBuy_fee" value="10"  v-model="firstModel" @input="getFirstCalGold">
              <span v-if="calGold2" style="margin-left: 10px; color: #ff0000;">税后实际到账积分：{{calGold2}}</span>
            </div> -->
              <br>
            </div>
            <div class="element">
              <div class="etitle">支付密码:</div>
              <div class="einput"><input
                  type="password"
                  placeholder="请输入支付密码"
                  id="WIDtotal_fee1"
                  name="WIDtotal_fee"
                  value="10"
                  v-model="payPwd"
                  autocomplete="new-password"
                ></div>
              <br>

            </div>
            <div
              class="element"
              style="display: none"
            >
              <input
                type="text"
                id="tokenId"
                name="tokenId"
                value="798cc3d3-56b0-44b2-848a-a3d6d306f253"
              >
            </div>
            <div class="element">
              <input
                class="alisubmit"
                @click="doTransfer()"
                type="button"
                value="立即兑换"
              >
            </div>
          </form>
        </div>

      </div>
    </div>

  </div>

</template>
<script>
import { getSession } from "utils/tool";
import { transferAccount, getCalGoldWithdraw } from "api/user";
import { transferType } from "utils/constant";
import { mapGetters } from "vuex";
import { encryptDes } from "utils/des";

export default {
  data() {
    return {
      showTransfer: "",
      transModel: "",
      firstModel: "",
      payPwd: "",
      transferType: transferType,
      calGold1: undefined,
      calGold2: undefined,
      timer: undefined,
      titleName: undefined,
      isFirstBuy: getSession("isFirstBuy"), //1具备店长资格 0 不具备
    };
  },
  created() {
    //   this.isFirstBuy = getSession('isFirstBuy');
    this.type1 = this.$route.query["type1"];
    this.type2 = this.$route.query["type2"];
    this.showTransfer = this.$route.query["showTransfer"];
    if (this.type1 === transferType.gold) {
      this.titleName = "奖金积分兑换";
    } else if (this.type1 === transferType.netStoreIncomePoints) {
      this.titleName = "商家余额兑换";
    }
  },
  methods: {
    getCalGold() {
      this.transModel = this.transModel
        .replace(/[^\d.]/g, "") // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, ".") // 只保留第一个. 清除多余的
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (this.transModel.indexOf(".") < 0 && this.transModel != "") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.transModel = parseFloat(this.transModel);
      }
      if (this.type1 !== transferType.gold) {
        return;
      }
      if (!this.transModel) {
        this.calGold1 = undefined;
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        let data = {
          loginName: getSession("userName"),
          money: this.transModel,
          type: 2,
        };
        getCalGoldWithdraw(data).then((res) => {
          if (res.resCode === 1) {
            this.calGold1 = res.data;
          }
        });
      }, 1000);
    },
    getFirstCalGold() {
      // this.firstModel = this.firstModel
      //   .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      //   .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      //   .replace('.', '$#$')
      //   .replace(/\./g, '')
      //   .replace('$#$', '.')
      //   .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
      // if (this.firstModel.indexOf('.') < 0 && this.firstModel != '') {
      //   // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
      //   this.firstModel = parseFloat(this.firstModel);
      // }
      // if (this.type2 !== transferType.firstGold) {
      //   return;
      // }
      // if (!this.firstModel) {
      //   this.calGold2 = undefined;
      //   return;
      // }
      // if (this.timer) {
      //   clearTimeout(this.timer);
      // }
      // this.timer = setTimeout(() => {
      //     let data = {
      //       money: this.firstModel,
      //       type: 2
      //     }
      //   getCalGoldWithdraw(data).then(res => {
      //     if (res.resCode === 1) {
      //       this.calGold2 = res.data;
      //     }
      //   });
      // }, 1000);
    },
    doTransfer() {
      //  debugger
      // if (this.transModel != '' && this.firstModel != '') {
      //      this.$Message.warning('通用商城购物积分与店长采购积分不可同时兑换！');
      //      return;
      // }
      if (this.transModel == "" || this.transModel == undefined) {
        this.$Message.warning("请输入兑换金额！");
        return;
      }
      if (parseFloat(this.transModel) > parseFloat(this.showTransfer)) {
        this.$Message.warning("兑换金额不能大于可兑换金额！");
        return;
      }
      if (this.payPwd == "" || this.payPwd == undefined) {
        this.$Message.warning("请输入支付密码！");
        return;
      }
      if (this.payPwd.length > 1000) {
        this.$Message.warning("支付密码超限！");
        return;
      }
      let self = this;
      var lock = false;
      layer.confirm(
        "是否确定兑换?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          if (!lock) {
            lock = true; //锁定
            let typeId, convertMoney;
            // if(self.firstModel){ typeId = self.type2;convertMoney = self.firstModel;};
            if (self.transModel) {
              typeId = self.type1;
              convertMoney = self.transModel;
            }
            const postJson = {
              type: 29,
              point: convertMoney,
              paymentPassword: self.payPwd,
            };
            console.log(postJson);
            // const postBody = encryptDes(JSON.stringify(postJson));
            let postBody = self.$Rsa.encrypt(JSON.stringify(postJson));
            transferAccount(postBody).then((res) => {
              if (res.resCode == 1) {
                layer.msg("积分兑换成功！", { icon: 1 });
                setTimeout(function () {
                  self.$router.push({
                    path: "/account-center",
                  });
                }, 2000);
              } else {
                layer.msg(res.resDesc, { icon: 2 });
                return;
              }
            });
          }
        },
        function () {}
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/showTransfer.less";
</style>



// WEBPACK FOOTER //
// showTransfer.vue?b16d9862